/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRapidAlertMsg.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/rapid-alert_msg";

export class AutogenModelRapidAlertMsg<RowType extends ModelRow> extends Endpoint<RowType, RowRapidAlertMsgFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRapidAlertMsg extends ModelRow<RowRapidAlertMsgFields> {
	constructor(values?: Partial<RowRapidAlertMsgFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRapidAlertMsgFields {
	alert_id: string;
	alert_type: string;
	attachment: string;
	attachment_ext: string;
	company_id: string;
	created_date: Date;
	entered_by_userid: string;
	id: string;
	is_confirmed: string;
	is_read: string;
	msg: string;
	parent_message_id: string;
	parent_row_id: string;
	parent_row_type: string;
	priority: string;
	user_id: string;
}

